export const INDIVIDUALS_ACTIONS = {
    GET_ALL: 'INDIVIDUALS_GET_ALL',
    GET_ACTIVE: 'INDIVIDUALS_GET_ACTIVE',
    FIND: 'INDIVIDUALS_FIND',
    ADD: 'INDIVIDUAL_ADD',
    CLEAN: 'INDIVIDUALS_CLEAN',
    CHANGE_STATUS: 'INDIVIDUALS_CHANGE_STATUS',
    SUCCESS: 'INDIVIDUALS_SUCCESS',
    ERROR: 'INDIVIDUALS_ERROR',

    SUGGESTION: 'INDIVIDUALS_SUGGESTION',
    SUGGESTION_CLEAN: 'INDIVIDUALS_SUGGESTION_CLEAN',
}